import { render, staticRenderFns } from "./HoldingNoUpdate.vue?vue&type=template&id=61724110&scoped=true&"
import script from "./HoldingNoUpdate.vue?vue&type=script&lang=js&"
export * from "./HoldingNoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./HoldingNoUpdate.vue?vue&type=style&index=0&id=61724110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61724110",
  null
  
)

export default component.exports